import { useState, useEffect } from "react";
import { Calendar } from "lucide-react";
import { PopupModal } from "react-calendly";
import { useLanguage } from "../i18n/LanguageContext";

const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL;

export default function FloatingCTA() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [calendlyOpen, setCalendlyOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <>
      <button
        data-testid="floating-cta"
        onClick={() => setCalendlyOpen(true)}
        className="fixed bottom-20 left-1/2 -translate-x-1/2 z-40 btn-gold bg-[#D4AF37] text-[#0B1221] px-6 py-3 text-[11px] font-bold uppercase tracking-wider hover:bg-[#F59E0B] flex items-center gap-2 shadow-[0_4px_24px_rgba(212,175,55,0.3)] floating-cta-enter"
      >
        <Calendar size={14} />
        {t.nav.bookCall}
      </button>
      <PopupModal
        url={CALENDLY_URL}
        open={calendlyOpen}
        onModalClose={() => setCalendlyOpen(false)}
        rootElement={document.getElementById("root")}
      />
    </>
  );
}
